import React from 'react';
import styled from 'styled-components';
import * as CONSTANTS from '../constants';
import Entries from '../components/Entries.js';
import Link from 'next/link';
import { ModalContext } from '../context/modal';
import fetch from 'isomorphic-unfetch';

const ErrorHeadingWrap = styled.div`
  margin: 0 30px;
`;

const ErrorHeading = styled.h1`
  font-weight: 200;
  display: block;
  margin: 30px auto 0 auto;
  max-width: 500px;
  padding: 30px;
  text-align: center;
  font-size: 45px;
  border: 1px solid #f4f4f4;
  border-radius: 3px;
  box-sizing: border-box;

  ${props => (props.darkMode === true) ? `
    color: #fff;
    border-color: #242329;
    ` : ''}
`;

const RandomSitesWrap = styled.div`
  margin-bottom: 60px;
`;

const RandomSitesTitle = styled.h2`
  font-size: 18px;
  text-align: center;
  margin-top: 60px;
  font-weight: 200;
  padding: 0 30px;

  ${props => (props.darkMode === true) ? `
    color: #fff;
    ` : ''}
`;

const CTA = styled.a`
	font-size: ${CONSTANTS.ctaText};
	font-weight: 200;
	text-align: center;
	display: table;
	padding: 8px 30px;
	color: ${CONSTANTS.white};
	background-color: ${CONSTANTS.darkGray};
	margin: 30px auto 0 auto;
	border-radius: 3px;
	margin: 30px auto 0 auto;

	&:hover {
		background-color: ${CONSTANTS.fakeCtaOpacity};
  }
  
  ${props => (props.darkMode === true ? `color: #fff;background-color: #1a1a1a; &:hover{background-color: #141414;}` : '')}
`;

export default class Error extends React.Component {
  static async getInitialProps({ query }) {
    const res = await fetch(`${CONSTANTS.API_URL}?randoms=1`);
    const data = await res.json();
  
    return { randomEntries: data.entries }
  }

  render() {
    return (
      <React.Fragment>
        <ErrorHeadingWrap>
          <ErrorHeading darkMode={this.context.darkMode}>
            Sorry, we can't find the page you're looking for.
          </ErrorHeading>
        </ErrorHeadingWrap>
        <RandomSitesWrap>
          <RandomSitesTitle darkMode={this.context.darkMode}>While you're here, check out a few entries from the gallery…</RandomSitesTitle>
          <Entries entries={this.props.randomEntries} origin="sites" />
          <Link href="/">
						<CTA href="/" darkMode={this.context.darkMode}>Explore the full gallery</CTA>
					</Link>
        </RandomSitesWrap>
      </React.Fragment>
    );
  }
}

Error.contextType = ModalContext;
